/**
 * evnex-delivery-timeline-interactive.js
 * Highlights the active shipping estimate row and shows a compact
 * dispatch line above add-to-cart, based on selected colour variant.
 *
 * Handles two row layouts:
 *   - Color-only rows: .evnex-dt-row > .evnex-dt-pills > .evnex-dt-pill--[color]
 *   - Plug rows:       .evnex-dt-row > .evnex-dt-color-header + .evnex-dt-plug-row(s)
 */
(function () {
  'use strict';

  var HIGHLIGHT_CLASS = 'evnex-dt-row--active';
  var KNOWN_COLORS = ['snow', 'stone', 'sand', 'volcanic'];

  // Extract the colour token from the currently selected radio value
  // e.g. "Snow (indoor only)" -> "snow", "Stone" -> "stone"
  function getSelectedColor() {
    var checked = document.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < checked.length; i++) {
      var val = checked[i].value.toLowerCase();
      for (var j = 0; j < KNOWN_COLORS.length; j++) {
        if (val.indexOf(KNOWN_COLORS[j]) !== -1) return KNOWN_COLORS[j];
      }
    }
    return null;
  }

  // Get the colour token(s) a row represents, from its pill modifier classes
  // e.g. pill with class "evnex-dt-pill--snow" -> "snow"
  function getRowColors(row) {
    var pills = row.querySelectorAll('[class*="evnex-dt-pill--"]');
    var colors = [];
    pills.forEach(function (pill) {
      var match = pill.className.match(/evnex-dt-pill--(\w+)/);
      if (match) colors.push(match[1].toLowerCase());
    });
    return colors;
  }

  // Get the best date text for a row, considering the selected connection type
  // For plug rows: try to match socket vs tether; fall back to first plug row date
  // For color-only rows: just return the single date element
  function getDateForRow(row) {
    var plugRows = row.querySelectorAll('.evnex-dt-plug-row');

    if (plugRows.length > 0) {
      // Plug layout — try to match selected connection type
      var connectionChecked = null;
      var allChecked = document.querySelectorAll('input[type="radio"]:checked');
      for (var i = 0; i < allChecked.length; i++) {
        var val = allChecked[i].value.toLowerCase();
        if (val.indexOf('socket') !== -1 || val.indexOf('tether') !== -1 || val.indexOf('plug') !== -1) {
          connectionChecked = val;
          break;
        }
      }

      for (var j = 0; j < plugRows.length; j++) {
        var labelEl = plugRows[j].querySelector('.evnex-dt-plug-label');
        var label = labelEl ? labelEl.textContent.trim().toLowerCase() : '';
        if (connectionChecked) {
          if (connectionChecked.indexOf('socket') !== -1 && label.indexOf('socket') !== -1) {
            return getPlugRowDate(plugRows[j]);
          }
          if ((connectionChecked.indexOf('tether') !== -1 || connectionChecked.indexOf('plug') !== -1) && label.indexOf('tether') !== -1) {
            return getPlugRowDate(plugRows[j]);
          }
        }
      }
      // Fall back to first plug row date
      return getPlugRowDate(plugRows[0]);
    }

    // Color-only layout
    var dateEl = row.querySelector('.evnex-dt-tomorrow, .evnex-dt-ship, .evnex-dt-date');
    return dateEl ? cleanDateText(dateEl) : '';
  }

  function getPlugRowDate(plugRow) {
    var dateEl = plugRow.querySelector('.evnex-dt-tomorrow, .evnex-dt-ship, .evnex-dt-date');
    return dateEl ? cleanDateText(dateEl) : '';
  }

  // Extract clean timing text from a date element, stripping SVG whitespace and
  // leading "Ships " so dispatch line reads "Estimated dispatch: from 8 May 2026",
  // "Estimated dispatch: within 2-3 business days", "Estimated dispatch: tomorrow" etc.
  function cleanDateText(el) {
    var clone = el.cloneNode(true);
    clone.querySelectorAll('svg').forEach(function (svg) { svg.remove(); });
    var text = clone.textContent.trim().replace(/\s+/g, ' ');
    return text.replace(/^ships\s+/i, '');
  }

  function updateUI() {
  var dispatchLine = document.getElementById('evnex-dispatch-line');

  // Handle catch-all format (single message, no variant rows)
  var catchall = document.querySelector('.evnex-dt-catchall');
  if (catchall) {
    if (dispatchLine) {
      var catchallClone = catchall.cloneNode(true);
      catchallClone.querySelectorAll('svg').forEach(function (svg) { svg.remove(); });
      var text = catchallClone.textContent.trim().replace(/\s+/g, ' ');
      dispatchLine.textContent = 'Estimated dispatch: ' + text;
      dispatchLine.style.display = '';
    }
    return;
  }

  var rows = document.querySelectorAll('.evnex-dt-row');
  if (!rows.length) {
    // No shipping estimate at all on this product
    if (dispatchLine) dispatchLine.style.display = 'none';
    return;
  }

  var selectedColor = getSelectedColor();
  var matchedRow = null;

  rows.forEach(function (row) {
    row.classList.remove(HIGHLIGHT_CLASS);
    if (!selectedColor) return;
    var rowColors = getRowColors(row);
    if (rowColors.indexOf(selectedColor) !== -1) {
      row.classList.add(HIGHLIGHT_CLASS);
      if (!matchedRow) matchedRow = row;
    }
  });

  if (dispatchLine) {
    var targetRow = matchedRow || rows[0];
    var dateText = getDateForRow(targetRow);
    if (dateText) {
      dispatchLine.textContent = 'Estimated dispatch: ' + dateText;
      dispatchLine.style.display = '';
    } else {
      dispatchLine.style.display = 'none';
    }
  }
}

  function init() {
    document.addEventListener('change', function (e) {
      if (e.target.tagName === 'INPUT' && e.target.type === 'radio') {
        setTimeout(updateUI, 30);
      }
    });
    document.addEventListener('variant:changed', updateUI);
    updateUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();